module.exports = __webpack_public_path__ + "images/alfaromeo_smalld3b0844317ca432c0f790d1718e6149c.png";